import Breadcrumb from "@/components/Breadcrumb";

interface AnalysisBreadcrumbProps {
  analysisId: string | undefined;
}

export default function AnalysisBreadcrumb({
  analysisId,
}: AnalysisBreadcrumbProps) {
  return (
    <Breadcrumb
      items={[
        { label: "대시보드", to: "/" },
        { label: "분석", to: "/analyses" },
        { label: `분석 #${analysisId}`, to: `/analyses/${analysisId}` },
        { label: "분석 대시보드" },
      ]}
    />
  );
}
